import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faTrash } from '@fortawesome/free-solid-svg-icons';

const ModuleAccordion = ({ module, selectedIds, onTogglePermission, onToggleModule, onDeletePermission }) => {
    const [isOpen, setIsOpen] = useState(false);

    const isAllSelected = module.features.every(feature => selectedIds.includes(feature.permissionId));
    const isSomeSelected = module.features.some(feature => selectedIds.includes(feature.permissionId));

    return (
        <div className="bg-white dark:bg-[#1A1A1D] border border-gray-200 dark:border-gray-800 rounded-lg mb-3 overflow-hidden shadow-sm">
            {/* Header / Accordion Trigger */}
            <div 
                className="flex items-center justify-between p-4 cursor-pointer bg-gray-50 dark:bg-[#202022] hover:bg-gray-100 dark:hover:bg-[#252528] transition-colors"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="flex items-center gap-3">
                    <div 
                        className="flex items-center justify-center w-6 h-6 rounded-md bg-white dark:bg-black border border-gray-300 dark:border-gray-700 cursor-pointer"
                        onClick={(e) => {
                            e.stopPropagation();
                            onToggleModule(module, !isAllSelected);
                        }}
                    >
                        {isAllSelected && (
                            <div className="w-3 h-3 bg-primaryaccent rounded-sm"></div>
                        )}
                        {!isAllSelected && isSomeSelected && (
                            <div className="w-3 h-1 bg-gray-400 rounded-sm"></div>
                        )}
                    </div>
                    <h3 className="font-bold text-gray-800 dark:text-white text-xs">
                        {module.moduleName}
                    </h3>
                </div>
                <FontAwesomeIcon 
                    icon={isOpen ? faChevronUp : faChevronDown} 
                    className="text-gray-500 text-xs" 
                />
            </div>

            {/* Content / Features List */}
            {isOpen && (
                <div className="p-4 bg-white dark:bg-[#1A1A1D] border-t border-gray-200 dark:border-gray-800">
                    {module.features.map(feature => (
                        <div key={feature.permissionId} className="flex items-center justify-between py-3 border-b border-gray-100 dark:border-gray-800 last:border-0 last:pb-0">
                            <div className="flex flex-col pr-4 flex-1 overflow-hidden">
                                <span className="font-semibold text-gray-700 dark:text-gray-200 text-xs break-words">
                                    {feature.permissionKey}
                                </span>
                                {feature.description && (
                                    <span className="text-[10px] text-gray-500 mt-1 leading-snug break-words">
                                        {feature.description}
                                    </span>
                                )}
                            </div>
                            
                            {/* Toggle Switch */}
                            <label className="relative inline-flex items-center cursor-pointer shrink-0">
                                <input 
                                    type="checkbox" 
                                    value="" 
                                    className="sr-only peer" 
                                    checked={selectedIds.includes(feature.permissionId)}
                                    onChange={() => onTogglePermission(feature.permissionId)}
                                />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primaryaccent"></div>
                            </label>
                            
                            {/* Delete Button */}
                            <button
                                onClick={() => onDeletePermission(feature.permissionId)}
                                className="ml-4 text-gray-400 hover:text-red-500 transition-colors shrink-0 flex items-center justify-center w-8 h-8 rounded-full hover:bg-red-50 dark:hover:bg-red-900/20"
                                title="Delete Master Permission"
                            >
                                <FontAwesomeIcon icon={faTrash} className="text-xs" />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ModuleAccordion;
